import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetProjectItemsResponse } from '../../types/project';

export const ProjectDocumentApi = Symbol('ProjectDocumentApi');

export interface ProjectListItem {
    work_project_id: string;
    title: string;
}

export interface ProjectDocumentApi {
    getProjectList(): Promise<ProjectListItem[]>;
    getProjectItems(projectId: string): Promise<GetProjectItemsResponse>;
}

@injectable()
export class ProjectDocumentApiImpl extends PsHttpService implements ProjectDocumentApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/work/project`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getProjectList() {
        return this.get<PatSnapCommonResponseData<ProjectListItem[]>>({
            url: '/fetch-all',
        }).then((res) => {
            return res.data as ProjectListItem[];
        })
    }

    getProjectItems(projectId: string) {
        return this.post<PatSnapCommonResponseData<GetProjectItemsResponse>>({
            url: '/item/list',
            data: {
                work_project_id: projectId,
                node_ids: [],
                page: 1,
                limit: 50,
                display_type: 'upload',
            },
        }).then((res) => {
            return res.data as GetProjectItemsResponse;
        })
    }
}
